import { useTheme } from "@mui/system";

export default function ResultAnalysIcon({size = 40, props}) {
  const theme = useTheme();
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      {...props}
    >
      <path 
        d="M39.8062 14.1793L25.7887 0.19378C25.5304 -0.0645934 25.1054 -0.0645934 24.847 0.19378L22.0135 3.01922C21.7552 3.27759 21.7552 3.70266 22.0135 3.96103L22.9469 4.88617L2.74569 25.0476C-0.487837 28.2731 -1.01287 33.5489 1.96231 37.0078C3.67908 39.0081 6.08756 40.0083 8.49603 39.9999C10.6962 39.9999 12.8963 39.1665 14.5714 37.4912L35.0976 17.0131L36.031 17.9382C36.2894 18.1966 36.7144 18.1966 36.9727 17.9382L39.8062 15.1128C40.0646 14.8627 40.0646 14.4377 39.8062 14.1793ZM26.4971 20.0052H13.413L25.7471 7.69494L32.2891 14.221L26.4971 20.0052Z" 
        fill={theme.palette.rgd.primary}
      />
    </svg>
  )
}